/**
 * Shared chakra-react-select styles for registration forms.
 * Uses explicit light colours so dropdown menus stay readable when the
 * user's OS/browser is in dark mode (this app does not ship a dark theme).
 */
export function getRegistrationSelectStyles({ isReadOnly = false, minHeight } = {}) {
    const controlBg = isReadOnly ? '#F7FAFC' : '#FFFFFF';

    const lightIndicator = {
        bg: controlBg,
        backgroundColor: controlBg,
        color: '#4A5568',
        _dark: {
            bg: controlBg,
            backgroundColor: controlBg,
            color: '#4A5568',
        },
    };

    return {
        container: (provided) => ({
            ...provided,
            colorScheme: 'light',
        }),
        control: (provided) => ({
            ...provided,
            bg: controlBg,
            backgroundColor: controlBg,
            color: '#2D3748',
            _dark: {
                bg: controlBg,
                backgroundColor: controlBg,
                color: '#2D3748',
            },
            ...(minHeight ? { minHeight } : {}),
        }),
        valueContainer: (provided) => ({
            ...provided,
            bg: controlBg,
            backgroundColor: controlBg,
            color: '#2D3748',
            _dark: {
                bg: controlBg,
                backgroundColor: controlBg,
                color: '#2D3748',
            },
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            ...lightIndicator,
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            ...lightIndicator,
        }),
        clearIndicator: (provided) => ({
            ...provided,
            bg: 'transparent',
            backgroundColor: 'transparent',
            color: '#A0AEC0',
            _dark: {
                bg: 'transparent',
                backgroundColor: 'transparent',
                color: '#A0AEC0',
            },
        }),
        downChevron: (provided) => ({
            ...provided,
            color: '#4A5568',
            fill: '#4A5568',
            _dark: {
                color: '#4A5568',
                fill: '#4A5568',
            },
        }),
        crossIcon: (provided) => ({
            ...provided,
            color: '#A0AEC0',
            fill: '#A0AEC0',
            _dark: {
                color: '#A0AEC0',
                fill: '#A0AEC0',
            },
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            bg: '#E2E8F0',
        }),
        menu: (provided) => ({
            ...provided,
            bg: '#FFFFFF',
            zIndex: 20,
        }),
        menuList: (provided) => ({
            ...provided,
            bg: '#FFFFFF',
        }),
        option: (provided, state) => ({
            ...provided,
            bg: state.isFocused || state.isSelected ? '#EBF8FF' : '#FFFFFF',
            color: '#2D3748',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#2D3748',
        }),
        input: (provided) => ({
            ...provided,
            color: '#2D3748',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#A0AEC0',
        }),
        noOptionsMessage: (provided) => ({
            ...provided,
            color: '#718096',
        }),
    };
}
